import { Col, Row, Skeleton, Space, Tag, Typography } from "antd";
import { Content } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import UDF from "redux/models/udf";
import K from "utilities/constants";
import { selectUdf, setJobSourceUdf } from "redux/slices/udfSlice";
import {
  displayUdfFieldValues,
  getUdfDisplayValue,
} from "utilities/generalUtility";
import { displayDollar, formatBool } from "utilities/tableUtility";

const { Title } = Typography;

const SkeletonLoader = () => (
  <Content>
    <Skeleton active paragraph={{ rows: 5, width: "100%" }} title={false} />
  </Content>
);

export const JobDetails = ({ details }) => {
  const dispatch = useDispatch();

  const udfSlice = useSelector(selectUdf);

  const [loading, setLoading] = useState(true);

  const getJobUdfs = async (entityKeyId = null) => {
    try {
      const jobUdfs = await UDF.getEditUdfFields(
        {
          clientId: details.clientsId,
          entityId: K.UDF.Entities.JobSource.id,
          entityKey: K.UDF.Entities.JobSource.key,
          entityKeyId,
          isVisible: 1,
        },
        false,
      );

      dispatch(setJobSourceUdf(jobUdfs));
    } catch (error) {
      console.error("Error fetching job UDFs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getJobUdfs(details.id);
  }, []);

  if (loading) {
    return <SkeletonLoader />;
  }

  return (
    <Content className="collapse-details-wrap">
      <Row gutter={[20, 20]}>
        <Col xs={24} sm={12} lg={6}>
          <span className="field-label">Billing Tier</span>
          <Title level={5}>{details?.jobTier?.name}</Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Job Location</span>
          <Title level={5}>{details?.jobLocation.name}</Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Job Department</span>
          <Title level={5}>{details?.jobDepartment?.name ?? "N/A"}</Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Recruiting Start Date</span>
          <Title level={5}>
            {convertIntoDashUSFormat(details?.recruitingStartDate, false)}
          </Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Min Pay</span>
          <Title level={5}>
            {details?.minPay ? displayDollar(details?.minPay) : "N/A"}
          </Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Max Pay</span>
          <Title level={5}>
            {details?.maxPay ? displayDollar(details?.maxPay) : "N/A"}
          </Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>ATS ID</span>
          <Title level={5}>{details?.extAtsId ?? "N/A"}</Title>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span className="tag-title">Job Recruiter(s)</span>
          <Space wrap>
            {details?.jobRecruiters?.map((item) => (
              <div key={item.id} className="tag-wrap">
                <Tag color="blue" style={{ margin: 0 }}>
                  {item.recruiter.name ?? "N/A"}
                </Tag>
              </div>
            ))}
          </Space>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span className="tag-title">Job Hiring Manager(s)</span>
          <Space wrap>
            {details?.jobHiringManagers?.map((item) => (
              <div key={item.id} className="tag-wrap">
                <Tag color="blue" style={{ margin: 0 }}>
                  {item.hiringManager.name ?? K.NullPlaceholder}
                </Tag>
              </div>
            ))}
          </Space>
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <span>Notes</span>
          <Title level={5}>{details?.notes ?? "N/A"}</Title>
        </Col>

        {displayUdfFieldValues(udfSlice[K.Redux.JobSourceUdf])?.map((item) => (
          <Col key={item.id} xs={24} sm={12} lg={6}>
            <span>{item.label}</span>
            <Title level={5}>{getUdfDisplayValue(item)}</Title>
          </Col>
        ))}
      </Row>
    </Content>
  );
};
